import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';

import csCZ from 'utils/localization/csCZ';
import en from 'utils/localization/en';
import de from 'utils/localization/de';

const resources = {
	csCZ,
	en,
	de,
};

i18next.use(initReactI18next).init({
	resources,
	lng: 'csCZ',
	fallbackLng: 'csCZ',

	ns: Object.keys(resources.csCZ),
	fallbackNS: 'translation',

	interpolation: {
		escapeValue: false,
	},
	react: {
		useSuspense: true,
	},
});

// Map fallback namespace over all other namespaces
type MapFallback<T, Fallback extends keyof T> = {
	[key in keyof T]: T[key] & T[Fallback];
};

declare module 'react-i18next' {
	// eslint-disable-next-line
	interface Resources
		extends MapFallback<typeof resources['csCZ'], 'navigation'> {}
}
